<template>
    <div class="d-flex align-items-center">
        <Button id="previous-arrow-dashboard" @click.native="setPage(page - 1)" :disabled="prevDisabled" type="prev">
            <Icon icon="prev" width="10"/>
        </Button>
        <Button id="next-arrow-dashboard" :disabled="nextDisabled" @click.native="setPage(page + 1)" type="next">
            <Icon icon="next" width="10"/>
        </Button>
    </div>
</template>

<script>
import {usePagination, useRouter} from '../../../../core/hooks'
import Icon from '../../../../components/Theme/Icon'
import {watch, computed} from '@vue/composition-api'
import Button from './../Button'
import {dashboardUtils} from '../../../../core/utils'

export default {
    name: 'Pagination',
    components: {
        Icon,
        Button
    },
    props: {
        totalCount: Number
    },
    setup(props){
        const {route} = useRouter();
        
        const {page, setPage} = usePagination()

        const prevDisabled = computed(() => page.value < 2)
        const nextDisabled = computed(() => {
            const perPage = route.value.query.perPage || dashboardUtils.DEFAULT_PER_PAGE;
            return page.value >= Math.ceil(props.totalCount / perPage)
        })

        return {
            page,
            setPage,
            prevDisabled,
            nextDisabled
        }
    }
}
</script>

<style lang="scss" scoped>
    .rounded {
        padding: 13px 18px;
        background: #F0F2F5;
        border-radius: 50%!important;
    }
</style>